import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const TermsOfService: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="terms-of-service">
      <div className="container">
        <h1>{t('terms_of_service_title')}</h1>

        <section>
          <h2>{t('terms_section_1_title')}</h2>
          <p>{t('terms_section_1_content')}</p>
        </section>

        <section>
          <h2>{t('terms_section_2_title')}</h2>
          <p>{t('terms_section_2_content')}</p>
          <ul>
            <li>{t('terms_section_2_item_1')}</li>
            <li>{t('terms_section_2_item_2')}</li>
            <li>{t('terms_section_2_item_3')}</li>
          </ul>
        </section>

        <section>
          <h2>{t('terms_section_3_title')}</h2>
          <p>{t('terms_section_3_content_1')}</p>
          <p>{t('terms_section_3_content_2')}</p>
        </section>

        <section>
          <h2>{t('terms_section_4_title')}</h2>
          <p>{t('terms_section_4_content_1')}</p>
          <ul>
            <li>{t('terms_section_4_item_1')}</li>
            <li>{t('terms_section_4_item_2')}</li>
            <li>{t('terms_section_4_item_3')}</li>
          </ul>
          <p>{t('terms_section_4_content_2')}</p>
        </section>

        <section>
          <h2>{t('terms_section_5_title')}</h2>
          <p>{t('terms_section_5_content_1')}</p>
          <p>{t('terms_section_5_content_2')}</p>
          <p>{t('terms_section_5_content_3')}</p>
        </section>

        <section>
          <h2>{t('terms_section_6_title')}</h2>
          <p>{t('terms_section_6_content_1')}</p>
          <ul>
            <li>{t('terms_section_6_item_1')}</li>
            <li>{t('terms_section_6_item_2')}</li>
            <li>{t('terms_section_6_item_3')}</li>
            <li>{t('terms_section_6_item_4')}</li>
            <li>{t('terms_section_6_item_5')}</li>
          </ul>
        </section>

        <section>
          <h2>{t('terms_section_7_title')}</h2>
          <p>{t('terms_section_7_content_1')}</p>
          <p>{t('terms_section_7_content_2')}</p>
          <p>{t('terms_section_7_content_3')}</p>
        </section>

        <section>
          <h2>{t('terms_section_8_title')}</h2>
          <p>{t('terms_section_8_content_1')}</p>
          <ul>
            <li>{t('terms_section_8_item_1')}</li>
            <li>{t('terms_section_8_item_2')}</li>
            <li>{t('terms_section_8_item_3')}</li>
          </ul>
        </section>

        <section>
          <h2>{t('terms_section_9_title')}</h2>
          <p>{t('terms_section_9_content_1')}</p>
          <p>{t('terms_section_9_content_2')}</p>
        </section>

        <section>
          <h2>{t('terms_section_10_title')}</h2>
          <p>{t('terms_section_10_content_1')}</p>
          <p>{t('terms_section_10_content_2')}</p>
        </section>

        <section>
          <h2>{t('terms_supplementary')}</h2>
          <p>{t('terms_effective_date')}</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
